module.exports = __webpack_public_path__ + "static/media/abstract steuart 3.59b27c93.pxm";